<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="12" style="fill: var(--rf-icon-bg-fill, #fff)" />
      <path
        fill="inherit"
        stroke="none"
        d="M12.5 18h-1a.5.5 0 0 1-.5-.5v-6c0-.3.2-.5.5-.5h1c.3 0 .5.2.5.5v6c0 .3-.2.5-.5.5ZM12.7 8.7a1 1 0 0 1-.7.3 1 1 0 0 1-.7-.3A1 1 0 0 1 11 8c0-.3.1-.5.3-.7.2-.2.4-.3.7-.3.3 0 .5 0 .7.3.2.2.3.4.3.7 0 .3-.1.5-.3.7Z"
      />
    </svg>
  </span>
</template>
